import { Component, Input, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StateService } from '@uirouter/angular';
import { FilterService } from '../../core/services/core.filter.service';
import { NotificationHistoryHelper } from './gf-notification-history.service.component';
import { UiService } from '../../core/services/core.ui.service';
import { GfTranslateService } from '../../core/services/core.translate.service';
import { doGetPromise } from '../../core/config/core.httpclient-utils';
import * as _ from 'lodash';

@Component({
  selector: 'gf-notification-history',
  template: require('./gf-notification-history.component.html')
})
export class NotificationHistoryComponent implements OnInit {
  active = false;
  @Input() project: any;
  data: any;
  filters: any;
  sortFields: any;
  sort: any;
  paging: any;
  baseFilters: any;
  url: string = '/api/admin/0/notification';

  constructor(
    private stateService: StateService,
    private httpClient: HttpClient,
    private filterService: FilterService,
    private notificationHistoryHelper: NotificationHistoryHelper,
    private uiService: UiService,
    private translateService: GfTranslateService
  ) {}

  ngOnInit() {
    this.data = null;
    this.filters = false;
    
    this.sortFields = this.notificationHistoryHelper.getSortFields();
    this.sort = this.filterService.getSortValues();
    this.paging = this.filterService.getPagingValues();
    this.baseFilters = this.notificationHistoryHelper.getBaseFilters();
    this.filters = this.initFilters();
    this.refreshData();
  }

  onApplyFilters() {
    this.paging.page_num = 1;
    this.applyFilters();
  }

  onResetFilters() {
    this.paging.page_num = 1;
    this.filters = {
      main_fields: _.cloneDeep(this.baseFilters)
    };
    this.applyFilters();
  }

  onSort(params: any) {
    this.sort = {
      sort_field: _.get(params, 'key', 'id'),
      sort_dir: _.get(params, 'sortDir', 'desc')
    };
    this.applyFilters();
  }

  getDownloadUrl(format: string) {
    const fetchArgs = this.filterService.getFetchArgs({});
    fetchArgs.download = true;
    fetchArgs.format = format;
    delete fetchArgs.$inherit;

    const queryString = _.map(fetchArgs, (val, key) => `${encodeURIComponent(key)}=${encodeURIComponent(val)}`).join('&');

    return this.url + '?' + queryString;
  }

  onPaging(params: any) {
    _.assignIn(this.paging, params);
    this.applyFilters();
  }

  refreshData() {
    this.data = null;

    const fetchArgs = this.filterService.getFetchArgs({});
    if (this.project) {
      fetchArgs.project = this.project.unixName;
    }
    delete fetchArgs.unixName;

    doGetPromise(this.httpClient, this.url, fetchArgs)
    .then((response: any) => {
        this.data = _.get(response, 'items', []);
      },
      (response: any) => {
        this.data = [];
        const msg = this.translateService.translate('There was a problem loading Notifications data');
        this.uiService.message.showWarning(msg, 'Data Error');
      }
    );
  }

  private initFilters() {
    return {
      main_fields: this.notificationHistoryHelper.setFiltersFromStateParams(_.cloneDeep(this.baseFilters))
    };
  }

  private applyFilters(overrides: any = {}) {
    const base = this.stateService.params.unixName ? { unixName: this.stateService.params.unixName } : {};
    const newParams = _.pickBy(
      {
        ...base,
        ...this.sort,
        ...this.paging,
        ...this.filterService.getFilterValues(_.get(this.filters, 'main_fields', [])),
        ...overrides
      },
      (value) => value !== undefined && value !== null && value !== ''
    );

    this.stateService.go('.', newParams, { location: 'replace', notify: true, inherit: false })
    .then(() => {}, () => {});
  }
}
